function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import './ObjectFieldTemplate.css';
import { deepEquals } from 'react-jsonschema-form/lib/utils';
import cs from 'classnames';
import ExpandArraysContext from '../ExpandArraysContext';
import SemanticSection from '../../SemanticSection/SemanticSection';
import WidgetSizeContext from '../WidgetSizeContext/WidgetSizeContext';
import ValidateErrorsContext from '../ValidationForm/ValidateErrorsContext';
import GroupContext from '../GroupTemplate/GroupContext';
import isRootObject from './isRootObject';
import { useLabelIcons } from '../Widgets/utils/getLabelIcons';
import LazyContainer from '../../LazyContainer/LazyContainer';
import useIndentFields from '../IndentFieldsContext/useIndentFields';
import ObjectFieldTemplateChangeNotification from './ObjectFieldTemplateChangeNotification';
// if a title does not appear inside schema or ui:schema for the object,
// the rjsf library will fall back to the object key, which should not appear
// in the UI. Hence this replacement.
function getObjectTitle(schema, uiSchema) {
  var titleText = null,
    titleEscape = false;
  if (uiSchema !== undefined && uiSchema['ui:title'] !== undefined) {
    var uiTitle = uiSchema['ui:title'];
    if (typeof uiTitle === 'object') {
      titleText = uiTitle.text !== undefined ? uiTitle.text : null;
      titleEscape = uiTitle.escape === true;
    } else {
      titleText = uiTitle;
    }
  }
  if (titleText === null) {
    if (schema !== undefined && schema.title !== undefined) {
      titleText = schema.title;
    } else {
      titleText = '';
    }
  }
  return {
    text: titleText,
    escape: titleEscape
  };
}
function SchemaLayout(_ref) {
  var schemaLayout = _ref.schemaLayout,
    dmLayout = _ref.dmLayout,
    _ref$useGrid = _ref.useGrid,
    useGrid = _ref$useGrid === void 0 ? false : _ref$useGrid;
  var _useIndentFields = useIndentFields(),
    indentClassName = _useIndentFields.indentClassName;
  if (!useGrid) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, schemaLayout.map(function (child) {
      return dmLayout[child.id];
    }));
  }
  var gridGroups = [];
  schemaLayout.forEach(function (child) {
    var showChildInGrid = child.type === 'field';
    if (showChildInGrid) {
      if (gridGroups.length === 0 || gridGroups[gridGroups.length - 1].useGrid === false) {
        gridGroups.push({
          useGrid: true,
          children: []
        });
      }
      gridGroups[gridGroups.length - 1].children.push(child);
    } else {
      gridGroups.push({
        useGrid: false,
        children: [child]
      });
    }
  });
  var mappedGroups = gridGroups.map(function (group) {
    var groupedChildren = group.children.map(function (child) {
      var childId = child && child.hasOwnProperty('id') ? child.id : undefined;
      return dmLayout[childId];
    });
    var key = "group-".concat(groupedChildren.map(function (child) {
      return child ? child.key : '';
    }).join());
    return /*#__PURE__*/React.createElement("div", {
      className: cs('_dm-form-group__children', _defineProperty({
        '_dm-form-group__children--grid': group.useGrid
      }, indentClassName, group.useGrid && indentClassName)),
      key: key
    }, /*#__PURE__*/React.createElement(GroupContext.Provider, {
      value: group.useGrid
    }, groupedChildren));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, mappedGroups);
}
var ObjectTitleField = function ObjectTitleField(props) {
  var objectProps = props.objectProps,
    expandArrays = props.expandArrays,
    schemaChildren = props.schemaChildren,
    errors = props.errors,
    titleId = props.titleId,
    labelIcons = props.labelIcons;
  var TitleField = objectProps.TitleField,
    DescriptionField = objectProps.DescriptionField,
    description = objectProps.description,
    required = objectProps.required,
    formContext = objectProps.formContext,
    idSchema = objectProps.idSchema,
    uiSchema = objectProps.uiSchema,
    title = objectProps.title;
  var defaultOpen = expandArrays.defaultOpen,
    openOnError = expandArrays.openOnError;
  var expandForErrors = useMemo(function () {
    var $id = idSchema.$id;
    var result = false;
    if (openOnError && $id && $id.length && errors.length) {
      var id = $id.indexOf('_') === 0 ? $id.substring(1) : $id;
      var dsaErrors = errors.filter(function (error) {
        return error.property && error.property.indexOf(".".concat(id, ".")) !== -1;
      });
      result = dsaErrors.length > 0;
    }
    return result;
  }, [openOnError, errors, idSchema]);
  return /*#__PURE__*/React.createElement(TitleField, {
    id: titleId || "".concat(idSchema.$id, "__title"),
    idSchema: idSchema,
    defaultOpen: defaultOpen,
    expandForErrors: expandForErrors,
    title: title.text,
    escape: title.escape,
    groupUiIcons: labelIcons,
    required: required,
    formContext: formContext,
    help: uiSchema ? uiSchema['ui:help'] : '',
    description: description,
    DescriptionField: DescriptionField
  }, schemaChildren);
};
export function ObjectFieldTemplate(props) {
  var DescriptionField = props.DescriptionField,
    className = props.className,
    schema = props.schema,
    uiSchema = props.uiSchema,
    formContext = props.formContext,
    idSchema = props.idSchema,
    forwardedRef = props.forwardedRef,
    disabled = props.disabled,
    dmLayout = props.dmLayout,
    description = props.description,
    properties = props.properties;
  var widgetSize = React.useContext(WidgetSizeContext);
  var objectProps = Object.assign({}, props, {
    title: getObjectTitle(schema, uiSchema)
  });
  var title = objectProps.title;
  var hasTitle = title.text !== '' && title.text !== undefined;
  var schemaLayout = uiSchema['dm:layout'];
  var isTopLevel = isRootObject(idSchema, formContext, title);
  var inArray = false;
  if (!isTopLevel && idSchema.$id && /_\d+$/.test(idSchema.$id)) {
    var id = idSchema.$id.substring(1).replace(/_\d+$/, '');
    inArray = formContext.schema && formContext.schema.properties && formContext.schema.properties[id] && formContext.schema.properties[id].type && formContext.schema.properties[id].type === 'array';
  }
  var useGrid = widgetSize !== undefined && widgetSize !== 'small' && !isTopLevel && (inArray || hasTitle);
  var _children = schemaLayout ? /*#__PURE__*/React.createElement(SchemaLayout, {
    schemaLayout: schemaLayout,
    uiSchema: uiSchema,
    dmLayout: dmLayout,
    useGrid: useGrid,
    type: "group"
  }) : properties.map(function (prop) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, prop.content);
  });
  var schemaChildren = !isTopLevel && !inArray ? /*#__PURE__*/React.createElement(SemanticSection, null, _children) : _children;
  var titleId = hasTitle ? "".concat(idSchema.$id, "__title") : '';
  var _useLabelIcons = useLabelIcons(titleId, formContext, uiSchema),
    labelledBy = _useLabelIcons.labelledBy,
    labelIcons = _useLabelIcons.labelIcons;
  return /*#__PURE__*/React.createElement("div", {
    ref: forwardedRef,
    className: cs('_dm-form__object', 'auto-form-group', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, className, className), '_dm-form__object--print', formContext.isPrintView), '_dm-form__object--card', formContext.isCardView), '_dm-form__object--card-disabled', formContext.isCardView && disabled), '_dm-form__object--print-grid', isTopLevel && formContext.isPrintView), "_dm-form__object--print-grid--".concat(widgetSize), isTopLevel && formContext.isPrintView && widgetSize), "auto-form-group--".concat(idSchema.$id.indexOf('_') === 0 ? idSchema.$id.substring(1) : idSchema.$id), idSchema.$id && idSchema.$id.length)),
    role: "group",
    "aria-labelledby": labelledBy
  }, /*#__PURE__*/React.createElement(ObjectFieldTemplateChangeNotification, {
    isTopLevel: isTopLevel,
    schema: schema
  }), hasTitle && /*#__PURE__*/React.createElement(ExpandArraysContext.Consumer, null, function (expandArraysContext) {
    return /*#__PURE__*/React.createElement(ValidateErrorsContext.Consumer, null, function (errors) {
      return /*#__PURE__*/React.createElement(ObjectTitleField, {
        objectProps: objectProps,
        titleId: titleId,
        labelIcons: labelIcons,
        expandArrays: expandArraysContext,
        errors: errors,
        schemaChildren: schemaChildren
      });
    });
  }), !hasTitle && /*#__PURE__*/React.createElement(React.Fragment, null, description && /*#__PURE__*/React.createElement(DescriptionField, {
    id: "".concat(idSchema.$id, "__description"),
    description: description,
    formContext: formContext
  }), schemaChildren));
}
var TextContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(TextContainer, _React$Component);
  function TextContainer() {
    _classCallCheck(this, TextContainer);
    return _possibleConstructorReturn(this, _getPrototypeOf(TextContainer).apply(this, arguments));
  }
  _createClass(TextContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !deepEquals({
        schema: this.props.schema,
        uiSchema: this.props.uiSchema
      }, {
        schema: nextProps.schema,
        uiSchema: nextProps.uiSchema
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return TextContainer;
}(React.Component);
var _countTypes2 = function _countTypes(schemaDmLayout, reactDmLayout, tally) {
  var children = schemaDmLayout && schemaDmLayout.children;
  if (!!children && children.length > 0) {
    children.forEach(function (child) {
      if (child.type === 'group') {
        _countTypes2(child, reactDmLayout, tally);
      } else if (child.type === 'text') {
        tally.text++;
      } else {
        tally.schemaFields++;
        if (reactDmLayout[child.id]) {
          tally.reactFields++;
        }
      }
    });
  }
};
export var countTypes = function countTypes(schemaDmLayout, reactDmLayout) {
  var tally = {
    text: 0,
    schemaFields: 0,
    reactFields: 0
  };
  _countTypes2(schemaDmLayout, reactDmLayout, tally);
  return tally;
};
export var shouldDisplayGroup = function shouldDisplayGroup(tally) {
  return tally.reactFields > 0 || tally.schemaFields === 0 && tally.text > 0;
};
var appendChildren = function appendChildren(props) {
  processChildren(props);
  var result = [];
  if (isArray(props.children)) {
    props.children.forEach(function (element) {
      var elementId = element && element.hasOwnProperty('id') ? element.id : undefined;
      if (elementId) {
        var matchingProp = props.properties.find(function (prop) {
          return prop['name'] === elementId;
        });
        var matchingLayout = props.dmLayout[elementId];
        if (matchingProp && matchingProp.content) {
          result.push(matchingProp.content);
        } else if (matchingLayout) {
          result.push(matchingLayout);
        }
      }
    });
  }
  return result;
};
var handleChildUiSchema = function handleChildUiSchema(props) {
  var newProps = props;
  if (props.id && props.uiSchema) {
    if (props.uiSchema[props.id]) {
      newProps = _objectSpread({}, props, props.uiSchema[props.id]);
      newProps.uiSchema = props.uiSchema[props.id];
    } else {
      newProps = _objectSpread({}, props, props.uiSchema);
    }
  }
  if (!newProps.text && newProps['ui:title']) {
    var uiTitle = newProps['ui:title'];
    if (typeof uiTitle === 'object') {
      newProps.text = uiTitle.text;
      if (typeof uiTitle.escape === 'boolean') {
        newProps.escape = uiTitle.escape;
      }
    } else {
      newProps.text = newProps['ui:title'];
    }
  }
  return newProps;
};
var buildDmLayout = function buildDmLayout(props) {
  var dmLayout = {};
  var schemaLayout = props.schemaLayout,
    schema = props.schema,
    uiSchema = props.uiSchema,
    idSchema = props.idSchema,
    formContext = props.formContext,
    properties = props.properties,
    TitleField = props.TitleField,
    DescriptionField = props.DescriptionField;
  if (schemaLayout) {
    properties.forEach(function (element) {
      dmLayout[element.name] = element.content;
    });
    processChildren({
      children: schemaLayout,
      schema: schema,
      uiSchema: uiSchema,
      idSchema: idSchema,
      formContext: formContext,
      properties: properties,
      TitleField: TitleField,
      DescriptionField: DescriptionField,
      dmLayout: dmLayout
    });
  }
  return dmLayout;
};
var processChildren = function processChildren(props) {
  var children = props.children || [];
  var TitleField = props.TitleField,
    DescriptionField = props.DescriptionField,
    formContext = props.formContext,
    idSchema = props.idSchema,
    uiSchema = props.uiSchema,
    dmLayout = props.dmLayout;
  var TextTemplate = props.formContext.TextTemplate;
  var GroupTemplate = props.formContext.GroupTemplate;
  if (isArray(children)) {
    children.forEach(function (element) {
      if (element) {
        if (element.type === 'group') {
          var groupProps = handleChildUiSchema(_objectSpread({
            uiSchema: uiSchema
          }, element));
          if (isArray(element.children) && shouldDisplayGroup(countTypes(element, dmLayout))) {
            dmLayout[element.id] = /*#__PURE__*/React.createElement(GroupTemplate, Object.assign({
              TitleField: TitleField,
              key: element.id,
              formContext: formContext,
              idSchema: idSchema
            }, groupProps), appendChildren({
              children: element.children,
              schema: props.schema,
              uiSchema: uiSchema,
              idSchema: props.idSchema,
              formContext: props.formContext,
              properties: props.properties,
              dmLayout: props.dmLayout,
              TitleField: TitleField,
              DescriptionField: DescriptionField
            }));
          }
        }
        if (element.type === 'text') {
          var textProps = handleChildUiSchema(_objectSpread({
            uiSchema: uiSchema
          }, element));
          dmLayout[element.id] = /*#__PURE__*/React.createElement(TextContainer, Object.assign({
            formContext: formContext,
            key: element.id,
            type: 'text',
            schema: props.schema
          }, textProps), /*#__PURE__*/React.createElement(TextTemplate, Object.assign({
            formContext: formContext
          }, textProps)));
        }
      }
    });
  }
};
var filterAdditionalProperties = function filterAdditionalProperties(property) {
  var content = property.content;
  if (!content) {
    return true;
  }
  var props = content.props;
  if (!props) {
    return true;
  }
  var schema = props.schema;
  if (!schema) {
    return true;
  }
  return !schema.__additional_property;
};
var isArray = function isArray(tbd) {
  return Array.isArray(tbd);
};
var LayoutObjectFieldTemplate = function LayoutObjectFieldTemplate(props) {
  var formContext = props.formContext,
    idSchema = props.idSchema,
    schema = props.schema,
    uiSchema = props.uiSchema,
    TitleField = props.TitleField,
    DescriptionField = props.DescriptionField,
    properties = props.properties;
  var schemaLayout = useMemo(function () {
    return uiSchema && uiSchema['dm:layout'] ? _toConsumableArray(uiSchema['dm:layout']) : [];
  }, [uiSchema]);
  var _properties = useMemo(function () {
    var props = properties ? _toConsumableArray(properties) : [];
    return props.filter(filterAdditionalProperties);
  }, [properties]);
  var dmLayout = useMemo(function () {
    return buildDmLayout({
      schemaLayout: schemaLayout,
      properties: _properties,
      formContext: formContext,
      idSchema: idSchema,
      schema: schema,
      uiSchema: uiSchema,
      TitleField: TitleField,
      DescriptionField: DescriptionField
    });
  }, [schemaLayout, _properties, formContext, idSchema, schema, uiSchema, TitleField, DescriptionField]);
  // @ts-ignore
  return /*#__PURE__*/React.createElement(ObjectFieldTemplate, Object.assign({}, props, {
    properties: _properties,
    dmLayout: dmLayout
  }));
};

// @ts-ignore
var mergeRefs = function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var filteredRefs = refs.filter(Boolean);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 0) return filteredRefs[0];
  // @ts-ignore
  return function (inst) {
    var _iterator = _createForOfIteratorHelper(filteredRefs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ref = _step.value;
        if (typeof ref === 'function') {
          ref(inst);
        } else if (ref) {
          ref.current = inst;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
};
export default React.forwardRef(function (props, forwardRef) {
  var formContext = props.formContext,
    formData = props.formData,
    idSchema = props.idSchema;
  var id = idSchema && idSchema.$id;
  var parts = id ? id.split('_') : [];
  var number = parts.length > 0 ? parseInt(parts[parts.length - 1], 10) : 0;

  // create placeholder for searching for DSA entries that are not rendered
  var placeholder = useMemo(function () {
    return formData ? Object.keys(formData).map(function (key) {
      return key !== 'id' ? formData[key] : null;
    }).join(' ') : '';
  }, [formData]);

  // Top level object or static component
  if (!(formContext && formContext.lazyLoadDSA) || parts.length === 0 || isNaN(number)) {
    return /*#__PURE__*/React.createElement(LayoutObjectFieldTemplate, Object.assign({
      forwardedRef: forwardRef
    }, props));
  }
  return /*#__PURE__*/React.createElement(LazyContainer, {
    className: "_dm-form-group__children",
    placeholderHeight: "9.6em",
    placeholderI18nKey: placeholder,
    number: number
  }, function (_ref2) {
    var ref = _ref2.ref,
      className = _ref2.className;
    return /*#__PURE__*/React.createElement(LayoutObjectFieldTemplate
    /*
    // @ts-ignore */, Object.assign({
      className: className,
      forwardedRef: mergeRefs(forwardRef, ref)
    }, props));
  });
});